import { Component, OnInit, ChangeDetectorRef, Input, Output, EventEmitter } from '@angular/core';
import { ENTITY_VIEWER_MODE } from '../entity-manager/ENTITY_VIEWER_MODE';
import { Observable } from 'rxjs';
import { Navbar } from 'src/app/services/models/enums';
import { GlobalServiceService } from 'src/app/services/global/global-service.service';
import { ActiveNavbarOptions, getOrderByNavbarOption, SIDEBAR_LOGOUT_OPTION } from './sidebar-order-config';
import { AuthFacade } from 'src/app/auth/auth.facade';

interface Category {
  label: string;
  order: number;
  icon: string;
  action: () => void;
}
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: false,
})
export class SidebarComponent implements OnInit {
  @Input()
  classSidebar?: Observable<string>;

  @Output()
  selectedOptionNavbar = new EventEmitter<Navbar>();

  show: boolean = true;
  showSub: boolean = false;
  subSucur: boolean = false;
  ENTITY_VIEWER_MODE = ENTITY_VIEWER_MODE;

  userCountry: string | null = localStorage.getItem('userCountry');
  dashboardCountry: ActiveNavbarOptions = Navbar.dashboardCL;
  searchCountry?: string;
  opciones?: Navbar;
  labelName?: string;
  fasAlerts?: string;
  categories: Array<Category> = [];
  localNPE = localStorage.getItem('npe');
  npe: boolean = false;

  public classSidebarValue: string = '';
  report?: string;
  labelDashboard?: string;

  constructor(
    private readonly cd: ChangeDetectorRef,
    public globalServiceService: GlobalServiceService,
    private readonly authFacade: AuthFacade,
  ) {}

  ngOnInit() {
    this.classSidebar?.subscribe((resp) => (this.classSidebarValue = resp));
    switch (this.userCountry) {
      case 'AR':
        this.npe = this.localNPE === 'active';
        this.dashboardCountry = Navbar.dashboard;
        this.opciones = Navbar.opcionesCL;
        this.labelDashboard = 'Tablero';
        this.labelName = 'Personas';
        this.fasAlerts = 'fas fa-cogs';
        break;
      case 'CR':
        this.dashboardCountry = Navbar.dashboardCR;
        this.opciones = Navbar.opcionesCL;
        this.labelDashboard = 'Alertas';
        this.labelName = 'Documentos';
        this.fasAlerts = 'fas fa-bell';
        break;
      default:
        if (!this.globalServiceService.role) {
          this.dashboardCountry = Navbar.opcionesCL;
          this.opciones = Navbar.opcionesCL;
          this.labelDashboard = $localize`Alertas`;
        } else {
          this.dashboardCountry = Navbar.dashboardCL;
          this.opciones = Navbar.opcionesCL;
          this.labelDashboard = $localize`Tablero`;
        }
        this.labelName = $localize`:@@documents:Documentos`;
        this.fasAlerts = 'fas fa-bell';
        break;
    }

    this.categories = [
      {
        label: this.labelDashboard,
        order: getOrderByNavbarOption(this.dashboardCountry),
        icon: 'fas fa-home',
        action: () => this.emitSelectEvent(this.dashboardCountry),
      },
      {
        label: $localize`Carteras`,
        order: getOrderByNavbarOption(Navbar.carteras),
        icon: 'fas fa-briefcase',
        action: () => this.emitSelectEvent(Navbar.carteras),
      },
      {
        label: this.labelName,
        order: getOrderByNavbarOption(Navbar.personas),
        icon: 'fas fa-user-tie',
        action: () => this.emitSelectEvent(Navbar.personas),
      },
      {
        label: $localize`Favoritos`,
        order: getOrderByNavbarOption(Navbar.favoritos),
        icon: 'fas fa-star',
        action: () => this.emitSelectEvent(Navbar.favoritos),
      },
      {
        label: $localize`:@@processed_files:Archivos Procesados`,
        order: getOrderByNavbarOption(Navbar.orderTrackingProcessedFiles),
        icon: 'far fa-file-alt',
        action: () => this.emitSelectEvent(Navbar.orderTrackingProcessedFiles),
      },
      {
        label: 'FAQ',
        order: getOrderByNavbarOption(Navbar.preguntasFrecuentes),
        icon: 'fas fa-question-circle',
        action: () => this.emitSelectEvent(Navbar.preguntasFrecuentes),
      },
      {
        label: $localize`:@@sidebar_logout:Cerrar Sesión`,
        order: getOrderByNavbarOption(SIDEBAR_LOGOUT_OPTION),
        icon: 'fas fa-sign-out-alt',
        action: () => this.authFacade.logout(),
      },
    ];
  }

  isSelectedOption(order: number) {
    const selectedOrder = this.globalServiceService.orderSelected || 0;
    return selectedOrder === order;
  }

  toggle() {
    this.show = !this.show;
    this.cd.detectChanges();
  }

  selectItem(order: number) {
    this.globalServiceService.orderSelected = order;
    if (order === 7) {
      this.showSub = true;
    } else {
      this.showSub = false;
    }
  }

  subSucursales() {
    this.subSucur = !this.subSucur;
  }

  sucursales(value: string) {
    switch (value) {
      case 'adminAddSucursal':
        this.selectedOptionNavbar.emit(Navbar.adminAddSucursal);
        break;
      case 'adminEditSucursal':
        this.selectedOptionNavbar.emit(Navbar.adminEditSucursal);
        break;
      case 'adminDeleteSucursal':
        this.selectedOptionNavbar.emit(Navbar.adminDeleteSucursal);
        break;
      case 'adminShowSucursal':
        this.selectedOptionNavbar.emit(Navbar.adminShowSucursal);
        break;
    }
  }

  emitSelectEvent(value: Navbar): void {
    this.selectedOptionNavbar.emit(value);
  }
}
